<template>
  <div class="reveal">
    <div class="items">
      <div class="item" v-for="(item, key) in items">
        <div
          v-bind:class="{
            'is-active': active.some((element) => {
              return element === key;
            }),
          }"
          v-on:click="toggle(key, item.question)"
          v-bind:id="item.question | sanitize"
          v-bind:ref="item.question | sanitize"
        >
          <h4 class="pr-5 heading-xs">{{ item.question }}</h4>
        </div>
        <div
          class="mb-5 pr-md-5 content"
          v-show="
            active.some((element) => {
              return element === key;
            })
          "
        >
          <div v-html="item.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reval-faq",
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      active: [],
    };
  },
  filters: {
    sanitize(value) {
      return value.replace(/\s/g, "-").toLowerCase().replace(/&/g, "and");
    },
  },
  methods: {
    toggle(key, question) {
      // hash
      // history.pushState('', '', '#' + this.$options.filters.sanitize(question));

      /**
       *
       * findIndex
       * --> not supported on IE11 <--
       *
       * let item = this.active.findIndex((element) => {
       *     return element === key;
       * });
       *
       */

      // use polyfill instead
      let item = -1;
      this.active.some((element, index) => {
        if (element === key) {
          item = index;
          return true;
        }
      });
      // end polyfill

      if (item === -1) {
        this.active.push(key);

        this.$root.datalayer.push({
          event: "faqClick",
          faqClick: question,
        });
      } else {
        this.active.splice(item, 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.reveal {
  padding: 2rem 0;

  h4 {
    position: relative;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid $cc-resmed-grey-30;
    cursor: pointer;

    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: -2px;
      display: block;
      width: 1.75rem;
      height: 1.75rem;
      border-radius: 50%;
      background-color: $cc-resmed-action-red;
      // background-size: 1rem 1rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/icon-move-expand-white.svg);
    }
  }

  .is-active {
    h4 {
      &:after {
        background-image: url(#{$assets}/images/icon-less-collapse-white.svg);
      }
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.reveal {
  .item {
    ul,
    ol {
      margin: 1rem 0;
      padding-left: 2rem;
    }
  }
}
</style>